module.exports = __webpack_public_path__ + "static/media/rediness-view-icon.0607f838.svg";